// src/App.tsx
import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n';
import './App.css';

// Import des composants
import Navbar from './components/layout/Navbar';
import Hero from './components/sections/Hero';
import Services from './components/sections/Services';
import Portfolio from './components/sections/Portfolio';
import About from './components/sections/About';
import Contact from './components/sections/Contact';
import Footer from './components/layout/Footer';
import LoadingScreen from './components/common/LoadingScreen';
import ParticlesBackground from './components/effects/ParticlesBackground';

const App: React.FC = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={<LoadingScreen />}>
        <Router>
          <div className="App">
            <ParticlesBackground />
            <Navbar />
            <main>
              <Hero />
              <Services />
              <Portfolio />
              <About />
              <Contact />
            </main>
            <Footer />
          </div>
        </Router>
      </Suspense>
    </I18nextProvider>
  );
};

export default App;